const Groupon = window.Groupon;
const { h, render } = require('preact');
const App = require('./App');
const I18n = window.I18n;
const cardUI = require('grpn-card-ui/frontend/init.js')
window.cardUI = cardUI; 

const handleLandingSpinner = () => {
  let landingSpinner = document.getElementById('landing-spinner')
  if (landingSpinner)
    landingSpinner.style.display = 'none'
}

function removeFloatingContainer() {
  const floatChatEl = document.querySelector('.bcFloat');
  if (floatChatEl) {
      document.body.removeChild(floatChatEl);
  }
}

function initApp() {
  Groupon.Performance.pageReady()
  handleLandingSpinner()

  if(document.getElementById('main-app'))
    render(<App />, document.getElementById('main-app'));

  if(document.getElementById('faq-app')){
    let hashHandler = function(){
      window.location.reload()
    }
    window.addEventListener("hashchange", hashHandler, false);
    render(<App/>, document.getElementById('faq-app'));
  }
}

window.addEventListener('chat-ended', removeFloatingContainer);

if( document.readyState !== 'loading' ) {
  /* The document might already be ready when you come to attach the event and it would have already fired 'DOMContentLoaded' event
     The event has already fired by the time that code tries to hook it.
  */
  initApp()
} else {
    document.addEventListener('DOMContentLoaded', () => {
      initApp()
    })
}

(function () {
  //Polyfill for CustomEvent in IE
  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function(E, d, w) {
  // Polyfill for event.composedPath in IE and Edge
  if(!E.composedPath) {
    E.composedPath = function() {
      if (this.path) {
        return this.path;
      } 
    var target = this.target;
    
    this.path = [];
    while (target.parentNode !== null) {
      this.path.push(target);
      target = target.parentNode;
    }
    this.path.push(d, w);
    return this.path;
    }
  }
})(Event.prototype, document, window);
